import { render, staticRenderFns } from "./AddMessageForward.vue?vue&type=template&id=04dc3c50&"
import script from "./AddMessageForward.vue?vue&type=script&lang=js&"
export * from "./AddMessageForward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports